import { render } from "./grades.vue?vue&type=template&id=34348fa0&scoped=true"
import script from "./grades.vue?vue&type=script&lang=js"
export * from "./grades.vue?vue&type=script&lang=js"

import "@/assets/css/ts-table.css?vue&type=style&index=0&id=34348fa0&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34348fa0"]])

export default __exports__